import { TranslationContext } from "../Contexts/TranslationContext";
import * as React from "react";
import { Link, NavLink } from "react-router-dom";
import { Button, Container, Dropdown, DropdownItem, DropdownMenu, Grid, GridColumn, GridRow, Header, Menu, MenuItem, Message, Tab, TableCell, TableRow } from "@/components/bp/bp-ui";
import { CaseClient, CaseDetailModel, CaseDetailModelWithUrls, ClientResources, EvidenceListModel, KitPopulationModel, SampleListModel } from "@app/api2/api";
import { buildUrl, AppRoutes } from "../AppRoutes";
import { areYouSure } from "../AreYouSure";
import BPLoading from "@common/BPLoading";
import { BPSection } from "@common/BPSection";
import ItemsList from "@common/ItemsList";
import { PageHeader } from "@common/PageHeader";
import { replaceInString } from "@common/Utils";
import { GenderSelectorSelect } from "../CaseRun/RunTypes/Brutus/GenderSelector";
import { HandlerRegistry } from "../CaseRun/RunTypes/HandlerRegistry";
import { BPButton } from "@/components/bp/bpbutton";
import { BPContainer } from "@/components/bp/bpcontainer";

interface CaseDetailsProps {
    caseId: number;
    labId: number;
}

interface CaseDetailsState {
    model?: CaseDetailModel;
    res?: CaseDetailModelWithUrls;
}

export class CaseDetails extends React.Component<CaseDetailsProps, CaseDetailsState> {
    client: CaseClient = new CaseClient();
    tc: React.Context<ClientResources>;


    constructor(props) {
        super(props);

        this.state = {
            // loading: true,
        };
    }

    async componentDidMount(): Promise<any> {
        const result = await this.client.getCaseDetail(this.props.labId, this.props.caseId)

        // const runTypes = result.runTypes.map(x => { return x; });//.map((l) => ({ key: l.id, value: l.id, text: l.name }))
        // //const locales = await this.translationClient.getLocales();
        this.setState({
            model: result.model,
            res: result
            // runTypes: runTypes,
            // loading: false,
        });
    }

    render() {
        if (this.state.model == null)
            return <BPLoading />
        else
            return (<TranslationContext.Consumer>{t =>
                <BPContainer>
                    <PageHeader
                        header={replaceInString(t.caseView.caseDetailHeader, { '{caseName}': this.state.model.name })}
                        subheader={this.state.model.agencyName}
                        renderRight={() => {
                            return (
                                <>
                                    {!this.state.model.isReadOnly && this.state.model.isActive && (
                                        <>
                                            <MenuItem fitted>
                                                <Dropdown text={t.caseView.createRun} button>
                                                    <DropdownMenu>
                                                        {this.state.model.canCreateRunTypes.length &&
                                                            this.state.model.canCreateRunTypes.map(rt => {
                                                                // return (<DropdownItem key={rt.runType} as={Link} to={`/lab/${this.props.labId}/case/${this.props.caseId}/run/create/${rt.runType}`}>
                                                                return (<DropdownItem key={rt.runType} as={Link} to={buildUrl(AppRoutes.CaseRunCreate, {
                                                                    labId: this.props.labId.toString(),
                                                                    caseId: this.props.caseId.toString(),
                                                                    runType: rt.runType
                                                                })}>
                                                                    {t.runType[rt.runType]}
                                                                </DropdownItem>)
                                                            })
                                                        }
                                                    </DropdownMenu>
                                                </Dropdown>
                                            </MenuItem>
                                                <MenuItem fitted>
                                                <Dropdown text={t.common.import} button>
                                                    <DropdownMenu>
                                                        {this.state.model.canCreateEvidence &&
                                                            <DropdownItem as="a" href={this.state.res.importEvidenceUrl}>
                                                                {t.common.evidence}
                                                            </DropdownItem>
                                                        }
                                                        {this.state.model.canCreateReference &&
                                                            <>
                                                                <DropdownItem as="a" href={this.state.res.importReferenceUrl}>
                                                                    {t.common.referenceProfile}
                                                                </DropdownItem>
                                                            </>
                                                        }
                                                    </DropdownMenu>
                                                </Dropdown>
                                            </MenuItem>
                                            <MenuItem fitted>
                                                <Dropdown text={t.common.upload} button>
                                                    <DropdownMenu>
                                                        {this.state.model.canCreateEvidence &&
                                                            <DropdownItem as="a" href={this.state.res.uploadEvidenceUrl}>
                                                                {t.common.evidence}
                                                            </DropdownItem>
                                                        }
                                                        {this.state.model.canCreateReference &&
                                                            <>
                                                                <DropdownItem as="a" href={this.state.res.uploadReferenceUrl}>
                                                                    {t.common.referenceProfile}
                                                                </DropdownItem>
                                                                <DropdownItem as="a" href={this.state.res.uploadReferenceKeyboardUrl}>
                                                                    {t.common.referenceProfileKeyboard}
                                                                </DropdownItem>
                                                            </>
                                                        }
                                                        <DropdownItem as={Link} to={buildUrl(AppRoutes.CaseCustomPanelUpload, { caseId: this.props.caseId, labId: this.props.labId })}>
                                                            {t.customPanel.customPanel}
                                                        </DropdownItem>
                                                    </DropdownMenu>
                                                </Dropdown>
                                            </MenuItem>
                                            <MenuItem fitted>
                                                <BPButton as={Link} to={buildUrl(AppRoutes.CaseEdit, {
                                                    caseId: this.props.caseId,
                                                    labId: this.props.labId
                                                })}>{t.common.edit}</BPButton>
                                            </MenuItem>
                                            <MenuItem fitted>
                                                <BPButton negative onClick={() => this.deleteCase()}>{t.common.delete}</BPButton>
                                            </MenuItem>
                                        </>
                                    )}
                                    {!this.state.model.isActive &&

                                        <Message warning>
                                            <Header>Deleted</Header>
                                            This case has been deleted and cannot be modified.
                                        </Message>}

                                </>
                            )
                        }}
                    />
                    <Grid>
                        <GridColumn width={16}>
                            <BPSection header={t.common.runs}>
                                <Tab
                                    menu={{ secondary: true, pointing: true }}
                                    panes={
                                        this.state.model.canViewRunTypes.filter(x => HandlerRegistry.hasOwnRunList(x.runType)).map(rtype => {
                                            return { menuItem: t.runType[rtype.runType], render: () => HandlerRegistry.renderRunList(rtype.runType, { canCreateEvidence: this.state.model.canCreateEvidence, ...this.props }) }
                                        })
                                    } />

                            </BPSection>
                        </GridColumn>
                        <GridRow columns={3}>
                            <GridColumn>
                                {this.state.model.canCreateReference &&
                                    <ItemsList
                                        filter={(item: SampleListModel, filterText: string) => item.name.toLowerCase().includes(filterText.toLowerCase())}
                                        scrolling
                                        header={t.common.referenceProfiles}
                                        items={this.state.model.samples.sort((x, y) => x.name.localeCompare(y.name))}
                                        renderRow={(sample: SampleListModel) => <TableRow key={sample.id}>
                                            <TableCell>
                                                <Link to={buildUrl(AppRoutes.SampleDetails, { caseId: this.props.caseId, labId: this.props.labId, sampleId: sample.id })}>{<GenderSelectorSelect showLabel={false} showIcon={true} value={sample.sex} name={'sex'} readOnly></GenderSelectorSelect>}{sample.name}</Link>
                                            </TableCell>
                                        </TableRow>}
                                    />
                                }
                            </GridColumn>
                            <GridColumn>
                                {this.state.model.canCreateEvidence &&
                                    <ItemsList
                                        filter={(item: EvidenceListModel, filterText: string) => item.name?.toLowerCase().includes(filterText?.toLowerCase())}
                                        scrolling
                                        header={t.common.evidence}
                                        items={this.state.model.evidence.sort((x, y) => x.name.localeCompare(y.name))}
                                        renderRow={(evidence: EvidenceListModel) => <TableRow key={evidence.id}>
                                            <TableCell>
                                                <Link to={buildUrl(AppRoutes.EvidenceDetails, { caseId: this.props.caseId, labId: this.props.labId, evidenceId: evidence.id })}>{evidence.name}</Link>
                                            </TableCell>
                                        </TableRow>}
                                    />
                                }
                            </GridColumn>
                            <GridColumn>
                                {this.state.model.populations.length > 0 &&
                                    <ItemsList
                                        // filter={(item: EvidenceListModel, filterText: string) => item.name?.toLowerCase().includes(filterText?.toLowerCase())}
                                        scrolling
                                        header={t.customPanel.customPanels}
                                        items={this.state.model.populations.sort((x, y) => x.name.localeCompare(y.name))}
                                        renderRow={(pop: KitPopulationModel) => <TableRow key={pop.id}>
                                            <TableCell>
                                                <Link to={buildUrl(AppRoutes.CaseCustomPanelEdit, { caseId: this.props.caseId, labId: this.props.labId, panelId: pop.id })}>{pop.name}</Link>
                                            </TableCell>
                                        </TableRow>}
                                    />
                                }
                            </GridColumn>
                        </GridRow>
                    </Grid>
                </BPContainer>
            }</TranslationContext.Consumer>);
    }

    // private RenderItemList(header, items, renderRow): React.ReactNode {
    //     return <BPBoxWithHeader
    //         header={header}>
    //         <Table striped
    //             tableData={items}
    //             renderBodyRow={renderRow}>
    //         </Table>
    //     </BPBoxWithHeader>;
    // }

    @areYouSure(() => { return { message: window.translation.caseView.deleteCaseConfirm, title: window.translation.common.confirmDelete }; })
    async deleteCase() {
        await this.client.delete(this.props.labId, this.props.caseId);
    }
}


